import { createApp } from 'vue'
import ZaoshengWidget from './ZaoshengWidget.vue'

const el = document.getElementById('ai-zaosheng-wrap')
if (el) {
  const logoUrl = el.getAttribute('data-logo-url') || ''
  const digitalHumanUrl = el.getAttribute('data-digital-human-url') || ''
  const buttonUrl = el.getAttribute('data-button-url') || 'https://hxai.sundeinfo.com/pc/button.gif'
  console.log('AI Widget Init - Digital Human URL:', digitalHumanUrl)
  createApp(ZaoshengWidget, { logoUrl, digitalHumanUrl, buttonUrl }).mount(el)
}
